module.exports = __webpack_public_path__ + "img/pd-img40.ead82843.jpg";